import {AppForm} from "../../../../../../../common/forms/app.form";
import {Injectable} from "@angular/core";
import {FormControl, Validators} from "@angular/forms";
import {ApplicationAppEntityApplicationRead, ApplicationAppEntityApplicationWrite} from "../../../../../../../openapi";

@Injectable()
export class CurrentDeliveryAddressForm extends AppForm {
  constructor() {
    super({
      changeDeliveryAddress: new FormControl(false, {nonNullable: true, validators: [Validators.required]}),

      changeDeliveryAddressCity: new FormControl({value: '', disabled: true}, {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      changeDeliveryAddressPostalCode: new FormControl({value: '', disabled: true}, {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      changeDeliveryAddressStreet: new FormControl({value: '', disabled: true}, {
        validators: [Validators.maxLength(255)],
        nonNullable: true
      }),
      changeDeliveryAddressHouseNumber: new FormControl({value: '', disabled: true}, {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      changeDeliveryAddressApartmentNumber: new FormControl({value: '', disabled: true}, Validators.maxLength(255)),

      changeDeliveryAddressCoOwner: new FormControl(false, {nonNullable: true, validators: [Validators.required]}),
      changeDeliveryAddressCoOwnerData: new FormControl({value: '', disabled: true}, {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(5000)]
      }),
    });
  }

  private get changeDeliveryAddressCity(): FormControl {
    return this.get('changeDeliveryAddressCity') as FormControl;
  }

  private get changeDeliveryAddressPostalCode(): FormControl {
    return this.get('changeDeliveryAddressPostalCode') as FormControl;
  }

  private get changeDeliveryAddressStreet(): FormControl {
    return this.get('changeDeliveryAddressStreet') as FormControl;
  }

  private get changeDeliveryAddressHouseNumber(): FormControl {
    return this.get('changeDeliveryAddressHouseNumber') as FormControl;
  }

  private get changeDeliveryAddressApartmentNumber(): FormControl {
    return this.get('changeDeliveryAddressApartmentNumber') as FormControl;
  }

  private get changeDeliveryAddressCoOwnerData(): FormControl {
    return this.get('changeDeliveryAddressCoOwnerData') as FormControl;
  }

  public changeDeliveryAddressChange(v: boolean) {
    if (!v) {
      this.changeDeliveryAddressCity?.reset();
      this.changeDeliveryAddressCity?.disable();

      this.changeDeliveryAddressPostalCode?.reset();
      this.changeDeliveryAddressPostalCode?.disable();

      this.changeDeliveryAddressStreet?.reset();
      this.changeDeliveryAddressStreet?.disable();

      this.changeDeliveryAddressHouseNumber?.reset();
      this.changeDeliveryAddressHouseNumber?.disable();

      this.changeDeliveryAddressApartmentNumber?.reset();
      this.changeDeliveryAddressApartmentNumber?.disable();
    } else {
      this.changeDeliveryAddressCity?.enable();
      this.changeDeliveryAddressPostalCode?.enable();
      this.changeDeliveryAddressStreet?.enable();
      this.changeDeliveryAddressHouseNumber?.enable();
      this.changeDeliveryAddressApartmentNumber?.enable();
    }
  }

  public changeDeliveryAddressCoOwnerChange(v: boolean): void {
    if (!v) {
      this.changeDeliveryAddressCoOwnerData?.reset();
      this.changeDeliveryAddressCoOwnerData?.disable();
    } else {
      this.changeDeliveryAddressCoOwnerData?.enable();
    }
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    return {
      ...this.value,
      changeDeliveryAddressCity: this.value.changeDeliveryAddressCity || null,
      changeDeliveryAddressPostalCode: this.value.changeDeliveryAddressPostalCode || null,
      changeDeliveryAddressStreet: this.value.changeDeliveryAddressStreet || null,
      changeDeliveryAddressHouseNumber: this.value.changeDeliveryAddressHouseNumber || null,
      changeDeliveryAddressApartmentNumber: this.value.changeDeliveryAddressApartmentNumber || null
    }
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead): void {
    this.changeDeliveryAddressChange(!!value?.changeDeliveryAddress);
    this.changeDeliveryAddressCoOwnerChange(!!value?.changeDeliveryAddressCoOwner);
    super.patchFormValues(value);
  }
}
